<template>
  <v-form ref="form" :disabled="loader.loading" @submit.prevent="submit">
    <v-card class="pa-8">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="model.name"
            variant="outlined"
            label="Nome"
            :rules="[rules.required]"
            :readonly="readonly"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="model.classpath"
            variant="outlined"
            label="Classe (Classpath)"
            :rules="[rules.required]"
            :readonly="readonly"
            placeholder="App\Services\Biometry\ProviderName"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <key-value-list-input v-model="credentialsList" :readonly="readonly" label="Credenciais" />
        </v-col>
      </v-row>

      <v-row v-if="!readonly" class="mt-4">
        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            type="submit"
            color="primary"
            size="large"
            :loading="loader.loading"
            :disabled="loader.loading"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-form>
</template>

<script lang="ts" setup>
import { useLoader } from '@/stores/loader'
import { ref, watch } from 'vue'
import type { BiometricProviderCreateRequest } from '@/services/BiometricProviderService'
import KeyValueListInput from '@/components/form/KeyValueListInput.vue'

const loader = useLoader()

const model = defineModel<BiometricProviderCreateRequest>({ required: true })

const emit = defineEmits<{
  submit: [ BiometricProviderCreateRequest ]
}>()

const { readonly = false } = defineProps<{
  readonly: boolean
}>()

interface CredentialItem {
  key: string
  value: string
}

const credentialsList = ref<CredentialItem[]>([])

const rules = {
  required: (v: string) => (!!v || readonly) || 'Campo obrigatório',
}

function submit() {
  const credentials: Record<string, string> = {}
  credentialsList.value.forEach((credential) => {
    if (credential.key && credential.value) {
      credentials[credential.key] = credential.value
    }
  })
  model.value.credentials = credentials
  emit('submit', model.value)
}

watch(() => model.value.credentials, (newCredentials) => {
  if (newCredentials) {
    credentialsList.value = Object.entries(newCredentials).map(([key, value]) => ({
      key,
      value,
    }))
  }
}, { immediate: true })

</script>
